import { BookOpen, Scale, Compass } from "lucide-react";
import { Reveal } from "./Reveal";

const CARDS = [
  { icon: BookOpen, title: "Understand", text: "Learn how Dubai’s property market works." },
  { icon: Scale, title: "Compare", text: "Explore locations, developers, property types, and payment plans." },
  { icon: Compass, title: "Decide", text: "Understand costs, potential returns, and risks before deciding on your next step." },
];

export function ValueProp() {
  return (
    <section className="relative py-24 sm:py-32 px-6 sm:px-10 overflow-hidden" data-testid="value-section">
      <div className="pointer-events-none absolute -top-32 right-[-10%] h-[420px] w-[420px] rounded-full bg-[#C7A76C]/15 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-[-10%] h-[360px] w-[360px] rounded-full bg-[#0B1F3A]/10 blur-3xl" />
      <div className="relative max-w-6xl mx-auto">
        <Reveal>
          <p className="eyebrow">Why a briefing</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3A]" data-testid="value-headline">
            Clarity before commitment.
          </h2>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="glass rounded-[28px] p-8 h-full transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(11,31,58,0.25)]" data-testid={`value-card-${c.title.toLowerCase()}`}>
                <div className="h-11 w-11 rounded-2xl border border-[#C7A76C]/40 bg-[#C7A76C]/10 grid place-items-center text-[#0B1F3A]">
                  <c.icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="font-display mt-8 text-xl font-semibold text-[#172033]">{c.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#697386]">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
